import React, { useState, useEffect } from "react";

const Counter = ({ start, end, duration }) => {
  const [count, setCount] = useState(start);
  const step = Math.ceil((end - start) / (duration * 60)); // Calcula el paso para llegar al final en la duración especificada

  useEffect(() => {
    if (count < end) {
      const timer = setTimeout(() => {
        setCount((prevCount) => prevCount + step); // Incrementa el contador por el paso calculado
      }, 1000); // Incrementa el contador cada segundo
      return () => clearTimeout(timer);
    }
  }, [count, end, step]);

  return <span>{count}</span>;
};

export default Counter;
